import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";

export default styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: "#586A84",
        fontSize: 14,
        padding: "7px 10px",
        gap: "10px",
        boxShadow: "0px 1px 10px rgba(0, 0, 0, 0.25)",
        borderRadius: 6,
    },
}));
